"use client";

import Link from "next/link";
import React, { useState, useCallback } from "react";
import Image from "next/image";
import Dropdown from "../../components/Dropdown";

const MobileMenuButton = ({ onClick, ariaExpanded }) => (
  <button
    onClick={onClick}
    className="text-white focus:outline-none"
    aria-label="Toggle Menu"
    aria-expanded={ariaExpanded}
  >
    <div className="space-y-1">
      <span className="block w-6 h-0.5 bg-white"></span>
      <span className="block w-6 h-0.5 bg-white"></span>
      <span className="block w-6 h-0.5 bg-white"></span>
    </div>
  </button>
);

const NavLink = ({ link }) => (
  <li className="group relative">
    <Link
      href={`/${link.url}` || "#"}
      className="px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200"
    >
      {link.text || "Unnamed Link"}
    </Link>
    {link.subMenu && link.subMenu.length > 0 && (
      <Dropdown
        subMenu={link.subMenu}
        renderItem={(subLink) => (
          <Link href={`/${subLink.url}` || "#"} className="block w-full">
            {subLink.text || "Unnamed Sub-Link"}
          </Link>
        )}
      />
    )}
  </li>
);

const Header = ({ logo, links, title }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  const handleToggleSubMenu = useCallback((id) => {
    setOpenSubMenu((prev) => (prev === id ? null : id));
  }, []);

  const closeMenu = useCallback(() => {
    setIsMenuOpen(false);
    setOpenSubMenu(null);
  }, []);

  return (
    <header className="bg-primary-accent text-white shadow-md w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <div className="flex-shrink-0 flex flex-row content-center items-center">
          {logo?.src && (
            <Link href="/" aria-label="Go to Homepage">
              <Image
                src={logo.src || "/placeholder.svg"}
                alt={logo?.alt || "Logo"}
                width={150}
                height={50}
                className="h-12 w-auto drop-shadow-md"
              />
            </Link>
          )}
          <div>
            <Link href="/" aria-label="Go to Homepage">
              {title && <h1 className="text-sm sm:text-lg  ml-4">{title}</h1>}
            </Link>
          </div>
        </div>

        <nav className="hidden mds:block">
          <ul className="flex space-x-4">
            {links.map((link) => (
              <NavLink key={link.id} link={link} />
            ))}
          </ul>
        </nav>

        <div className="mds:hidden">
          <MobileMenuButton
            onClick={() => setIsMenuOpen((prev) => !prev)}
            aria-expanded={isMenuOpen}
          />
        </div>
      </div>

      {isMenuOpen && (
        <div className="mds:hidden bg-secondary-accent drop-shadow-md border-b border-primary-accent text-white transition-all duration-300 ease-in-out max-h-screen overflow-hidden">
          <ul className="flex flex-col space-y-4 py-6">
            {links.map((link) => (
              <li key={link.id} className="relative">
                {link.subMenu && link.subMenu.length > 0 ? (
                  <div className="flex flex-row justify-between content-center px-4">
                    <Link
                      href={`/${link.url}` || "#"}
                      onClick={closeMenu}
                      className="w-full text-left align-center text-lg font-medium"
                    >
                      {link.text || "Unnamed Link"}
                    </Link>
                    {/* <div className="flex items-center">
                      {openSubMenu === link.id ? (
                        <IoIosArrowUp
                          className="text-white"
                          onClick={() => handleToggleSubMenu(link.id)}
                        />
                      ) : (
                        <IoIosArrowDown
                          className="text-white"
                          onClick={() => handleToggleSubMenu(link.id)}
                        />
                      )}
                    </div> */}
                  </div>
                ) : (
                  <Link
                    href={`/${link.url}` || "#"}
                    onClick={closeMenu}
                    className="w-full text-left py-2 px-4 text-lg font-medium"
                  >
                    {link.text || "Unnamed Link"}
                  </Link>
                )}
                <ul className="w-full pl-8  space-y-2">
                  {link.subMenu.map((subLink) => (
                    <li key={subLink.id}>
                      <Link
                        href={`/${subLink.url}` || "#"}
                        className="block py-1 text-sm text-gray-200 drop-shadow-md hover:text-white"
                        onClick={closeMenu}
                      >
                        {subLink.text || "Unnamed Sub-Link"}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
